import React from "react";

import { Check, FileCheck } from "lucide-react";

interface EmptyClientStateProps {
  isPending: boolean;
}

const EmptyClientState: React.FC<EmptyClientStateProps> = ({ isPending }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-muted-foreground">
      {isPending ? (
        <>
          <Check className="mb-2 h-12 w-12 text-green-500" />
          <p className="text-lg font-medium">
            No hay clientes pendientes de evaluación de riesgo
          </p>
        </>
      ) : (
        <>
          <FileCheck className="mb-2 h-12 w-12 text-blue-500" />
          <p className="text-lg font-medium">
            No hay clientes evaluados para mostrar
          </p>
        </>
      )}
    </div>
  );
};

export default EmptyClientState;
